module.exports = __webpack_public_path__ + "static/media/room-12.d84a664c.jpeg";